// src/lib/constants/featureFlags.ts

// Build-time feature flags (ADR-003 §1). Vite statically replaces import.meta.env.*
// at build; absent vars are undefined, so all flags default to false (production
// posture). Gating = conditional route registration + nav gating + flag-gated
// home redirect; non-exposure is the requirement, not bundle exclusion.
export const FEATURE_FLAGS = {
  analyticsEnabled: import.meta.env.VITE_ANALYTICS_ENABLED === 'true',
  legacyReportsEnabled: import.meta.env.VITE_LEGACY_REPORTS_ENABLED === 'true',
  // Delivery ("CDN Delivery") view inside /analytics — staged dark at launch,
  // flipped on post-parity (ADR-010 §3). Subordinate to analyticsEnabled: the
  // whole section is unreachable without that flag.
  analyticsDeliveryEnabled: import.meta.env.VITE_ANALYTICS_DELIVERY_ENABLED === 'true',
} as const;
